export default __webpack_public_path__ + "static/media/suite-montanha.a5dbce60.jpg";